import {ApplicationSetting} from "../entities/ApplicationSetting";
import {BaseService} from "./BaseService";
import { StateService } from "@uirouter/angularjs";
import { AuthenticationData } from "../entities/AuthenticationData";

export class ApplicationSettingService extends BaseService<ApplicationSetting>{
    static $inject = ['$http','$q','$state','localStorageService'];
    static APPSETTINGSKEY:string = "LOCSTORAGEAPPSETTINGS";
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService, public locStorage:angular.local.storage.ILocalStorageService) {
        super($http, $q, $state, ApplicationSetting);
    }
    protected getBaseUrl():string{
        return "applicationsetting";
    }
    updateLicense(licenseKey:string){
        var config:any = {};
        return this.usePutHandler(this.getBaseUrl(),"license?licenseKey="+encodeURIComponent(licenseKey), config);
    }
    getUseMeters():ng.IPromise<boolean>{
        return this.getCached().then((data)=>{
            return data.useMeters;
        })
    }
    getUseFahrenheit():ng.IPromise<boolean>{
        return this.getCached().then((data)=>{
            return data.temperatureFormat == "Fahrenheit";
        })
    }
    getAuthenticationServer(): ng.IPromise<string> {
        return this.useGetHandler(this.getBaseUrl(), "AuthenticationServer", { skipAuthorization: true });
    }
    getAuthenticationData(): ng.IPromise<AuthenticationData> {
        return this.useGetHandler(this.getBaseUrl(), "AuthenticationData", { skipAuthorization: true });
    }
    testChirpstack(baseUrl: string, username: string, password: string): ng.IPromise<boolean> {
        var config: any = {};
        return this.useGetHandler(this.getBaseUrl(), "ChirpstackTest?baseUrl=" + this.formatStr(baseUrl) + '&username=' + this.formatStr(username) + '&password=' + this.formatStr(password), config);
    }
    testCloudEmail(toRecipient: string, username: string, password: string): ng.IPromise<boolean> {
        var config: any = {};
        return this.usePostHandler(this.getBaseUrl(), "TestCloudEmail?toRecipient=" + this.formatStr(toRecipient) + '&username=' + this.formatStr(username) + '&password=' + this.formatStr(password), config);
    }
    testSmtpEmail(host: string, port:number, username: string, password: string, toRecipient:string, enableSsl:boolean): ng.IPromise<boolean> {
        var config: any = {};
        return this.usePostHandler(this.getBaseUrl(), "TestSmtpEmail?emailHost=" + this.formatStr(host) +
            '&emailPort=' + port +
            '&emailUsername=' + this.formatStr(username) +
            '&emailPassword=' + this.formatStr(password) +
            '&enableSsl=' + enableSsl +
            '&toRecipient=' + this.formatStr(toRecipient), config);
    }

    getCached(reset:boolean=false):ng.IPromise<ApplicationSetting>{

        if(reset)
            ApplicationSetting.applicationSetting = null;
        var appSettings = ApplicationSetting.applicationSetting;
        if(appSettings != null) {
            return this.$q.when<ApplicationSetting>(appSettings);
        }
        else{
            return this.getMostRecent().then((data)=>{
                var appSettings = data;
                ApplicationSetting.applicationSetting = data;
                return appSettings;
            });
        }
    }
    getCached2(reset:boolean=false):ng.IPromise<ApplicationSetting>{

        var appSettingsStr:string = this.locStorage.get<string>(ApplicationSettingService.APPSETTINGSKEY);
        var appSettings = null;
        if(appSettingsStr != null && !reset) {
            var appSettingsJson = JSON.parse(appSettingsStr);
            appSettings = new ApplicationSetting();
            appSettings.parseJson(appSettingsJson);
            ApplicationSetting.applicationSetting = appSettings;
            return this.$q.when<ApplicationSetting>(appSettings);
        }
        else{
            return this.getMostRecent().then((data)=>{
                var appSettings = data;
                var appSettingsStr = JSON.stringify(data);
                ApplicationSetting.applicationSetting = data;
                this.locStorage.set(ApplicationSettingService.APPSETTINGSKEY,appSettingsStr);
                return appSettings;
            });
        }
    }
}
